import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { CustomField } from '../types';
import { Button } from '@/components/Button';

interface DeleteCustomFieldDialogProps {
  isOpen: boolean;
  field: CustomField | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * カスタムフィールド削除確認ダイアログ
 */
export default function DeleteCustomFieldDialog({
  isOpen,
  field,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteCustomFieldDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>項目を削除しますか？</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="p-lg">
          <AlertDialogDescription>
            {field && (
              <span className="block text-sm text-gray-600">
                「<span className="font-bold text-gray-800">{field.name}</span>
                」を削除します。この操作は取り消せません。
              </span>
            )}
          </AlertDialogDescription>
        </div>
        <AlertDialogFooter>
          <Button color="secondary" size="md" onClick={onClose} disabled={isDeleting}>
            キャンセル
          </Button>
          <Button color="danger" size="md" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
